jQuery(document).ready(function($) {
    $('.location--multiple__trigger').on('click', function() {
        $(this).parents('.location').toggleClass('open');
    });
    $('.location--past__trigger').on('click', function() {
        $(this).toggleClass('open');
        $('.past-location-list').toggleClass('open');
    });
});
